import React from "react";
import { useIntl } from "react-intl";
import { Typography } from "@material-ui/core";
import LateralityValue from "../../protocol/components/LateralityValue";

export default ({ isBilateral }) => {
  const intl = useIntl();

  return (
    <Typography
      style={{
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.24",
        wordBreak: "break-word",
        maxWidth: "250px",
      }}
    >
      <LateralityValue isBilateral={isBilateral} />
    </Typography>
  );
};
